import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const clientAttachmentService = {
  listAttachments,
  uploadAttachment,
  deleteAttachment,
}

export function listAttachments(debtorCode) {
  return apiHelper(API_URL).get(`/customers/${encodeURIComponent(debtorCode)}/attachments`)
}

export function uploadAttachment(debtorCode, file, description = '') {
  const form = new FormData()
  form.append('file', file)
  if (description) form.append('description', description)
  return apiHelper(API_URL).post(
    `/customers/${encodeURIComponent(debtorCode)}/attachments`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
}

export function deleteAttachment(debtorCode, uuid) {
  return apiHelper(API_URL).delete(`/customers/${encodeURIComponent(debtorCode)}/attachments/${uuid}`)
}
